/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileFontLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileFontLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M29.3 27 22 49.607h2.753l2.245-6.956h8.508l2.245 6.956h2.752L33.205 27h-3.906Zm-1.46 13.042 3.412-10.567 3.411 10.567h-6.822Zm22.625-1.739v1.536a3.402 3.402 0 0 0-3.057-1.535c-3.554 0-5.676 2.112-5.676 5.651 0 3.539 2.122 5.652 5.677 5.652a3.305 3.305 0 0 0 1.81-.49 3.285 3.285 0 0 0 1.246-1.394v1.884h2.62V38.303h-2.62Zm-3.056 8.695c-2.114 0-3.057-.939-3.057-3.043s.943-3.043 3.057-3.043c2.113 0 3.056.939 3.056 3.043s-.943 3.043-3.056 3.043Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22 49.607 29.3 27h3.905l7.298 22.607h-.322L33.205 28h-3.906l-6.976 21.607H22Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m28.164 40.042-.323 1h6.822l-.322-1h-6.177Zm22.301-.739v-1h2.62v1h-2.62Zm0 .536a3.402 3.402 0 0 0-3.057-1.535c-3.554 0-5.676 2.112-5.676 5.651 0 .17.005.337.015.5.192-3.237 2.278-5.152 5.662-5.152a3.402 3.402 0 0 1 3.056 1.536v-1Zm-6.093 4.616c.145 1.754 1.099 2.543 3.037 2.543s2.892-.79 3.037-2.543c.013.159.02.325.02.5 0 2.104-.944 3.043-3.057 3.043-2.114 0-3.057-.939-3.057-3.043 0-.175.007-.341.02-.5Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileFontLarge
};
